import {
  collection,
  doc,
  serverTimestamp,
  setDoc,
} from "firebase/firestore";

export function createTournamentEventRef(db, tournamentId) {
  return doc(collection(db, "tournaments", tournamentId, "events"));
}

export function buildTournamentEventData({
  type,
  title,
  message = "",
  actorUid = null,
  actorName = "",
  playerUid = null,
  playerName = "",
  relatedPlayerUid = null,
  relatedPlayerName = "",
  metadata = {},
}) {
  return {
    type: String(type || "activity"),
    title: String(title || "Tournament activity"),
    message: String(message || ""),
    actorUid: actorUid || null,
    actorName: String(actorName || ""),
    playerUid: playerUid || null,
    playerName: String(playerName || ""),
    relatedPlayerUid: relatedPlayerUid || null,
    relatedPlayerName: String(relatedPlayerName || ""),
    metadata: metadata && typeof metadata === "object" ? metadata : {},
    createdAt: serverTimestamp(),
  };
}

export async function logTournamentEvent({
  db,
  tournamentId,
  ...event
}) {
  if (!db || !tournamentId) return;
  const ref = createTournamentEventRef(db, tournamentId);
  await setDoc(ref, buildTournamentEventData(event));
}
